import { createContext } from "react";
export const MatchedReadingsReducer = (prev, next) => {
    return { ...prev, ...next };
};
export const MatchedReadingsContext = createContext({
    state: { bucketedHistory: null, matchedHistory: null, bufferMins: 0, matchType: 'MatchHistoryStore' },
    dispatch: () => { },
});
